import styled from 'styled-components'
import { styleUtils } from 'styles'

/**
 *! We purposely omit children from the props here so the Placeholder will never render child elements.
 */

export const Placeholder = styled.div.attrs({
  children: null,
})`
  animation: placeholder-${({ $placeholderColor }) =>
      $placeholderColor || 'text'} 1s linear infinite;
  border-radius: ${({ theme }) => theme.borderRadius}rem;
  @keyframes placeholder-${({ $placeholderColor }) =>
    $placeholderColor || 'text'} {
    0% {
      background-color: ${({ $placeholderColor = 'text', theme }) =>
        styleUtils.colors.fade(theme.colors[$placeholderColor], 0.02)};
    }
    50% {
      background-color: ${({ $placeholderColor = 'text', theme }) =>
        styleUtils.colors.fade(theme.colors[$placeholderColor], 0.08)};
    }
    100% {
      background-color: ${({ $placeholderColor = 'text', theme }) =>
        styleUtils.colors.fade(theme.colors[$placeholderColor], 0.02)};
    }
  }
`
